import React from 'react';
export function Footer() {
  return <footer className="w-full py-4 text-center" data-id="element-28">
      <p className="text-xs text-white/40 font-body tracking-wide" data-id="element-29">
        © Solventum 2025
      </p>
    </footer>;
}